import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
//import { APIImportPreferenceService } from '../../_services/import-preference/API-import-preference';
import { APIEntityService } from '../../_services/entity/API-entity';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
//import { saveAs as importedSaveAs } from "file-saver";   
import { map } from 'rxjs/operators';


const today = new Date();
var time_today = today.getTime();
let now = new Date();
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');

@Component({
  selector: 'app-entity-worklist',
  templateUrl: './entity-worklist.component.html',
  styleUrls: ['./entity-worklist.component.css']
})
export class EntityWorklistComponent implements OnInit {
  maxDate: Date = new Date();

  fileDownload: any = [];
  dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['Entity_Ref_No', 'Entity_Class', 'E_Org_Name', 'E_Org_Type', 'Assigned_Timestamp','Request_Type','Operators','Entity_Creator',];
  /*  'Uploaded By', */
  form1: any = {};
  fetchedData: any;
  data: any = {};
  noRecord: any;

  onSubmitFilter(filterForm) {

    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = filterForm.currentDate;

    cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US');

    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US');

    var param
    if (filterForm.search)
      param = filterForm.search
    else if(filterForm.searchBy2)
      param = filterForm.searchBy2
    else if(filterForm.searchBy3)
      param = filterForm.searchBy3
   else
      param = filterForm.searchBy4


    if (typeof param === 'undefined' || param == null)
      param = "";



    var filterType
    if (filterForm.searchBy)
      filterType = filterForm.searchBy;
    if (fdate != "" && ldate == "") {
      ldate = cdate
    }

    this.data = {

      "Start_Date": fdate,
      "End_Date": ldate,
      "filterType": filterType,

      "param": param
    }
    if((!filterForm.endDate && !filterForm.search && !filterForm.searchBy && !filterForm.startDate) || filterForm.searchBy=="" && !filterForm.startDate){
      this.$modal.errorModal({
        title: 'Entity Worklist',
        msg: 'Please search by valid criteria'
      });
    }
    else if ((filterType != null && filterType != "") && (param == null || param=="")) {

      this.$modal.errorModal({
        title: 'Entity Worklist',
        msg: 'Please provide '+filterType+' value'
      });
    }
   else if (fdate == "" && ldate == "" && (filterType == null || filterType == "") && param == "") {
      this.$modal.errorModal({
        title: 'Entity Worklist',
        msg: 'Please select any option'
      });
    }
    else if (fdate > ldate) {
      this.$modal.errorModal({
        title: 'Entity Worklist',
        msg: 'From Date cannot be after To Date'
      });
    }
    else if (fdate == "" && ldate != "") {
      this.$modal.errorModal({
        title: 'Entity Report',
        msg: 'Please select Start date'
      });
    }
    else {

      this.imp.getWorklistSummaryFilter(this.data)
        .subscribe(r => {

          this.fetchedData = JSON.stringify(r.Data);
          this.dataSource = r.Data;
          this.onChangeDataSource(r.Data);
        });
    }
  }



  onChangeDataSource(value) {
    this.dataSubject.next(value);
    this.dataSource = new MatTableDataSource();

    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator;
    //  this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));

    console.log("dataSource : ", this.dataSource);
  }

  public preferencesummary: any;
  public Entity_ID: any;
  applyFilter(filterValue: string) {
    console.log("in filter");
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  GetDND_COMPLAINTS_TSP: any;
  dataSource: any;
  public reqId: any;
  public ncprFilename: any;
  public reqDate: any;
  public uploadedBy: any;
  public userName: any;
  form: any = {};
  showDropdown: boolean = false
  showDropdown1: boolean = false
  showDropdown2: boolean = false


  startDate1: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private imp: APIEntityService,
    private db: $DBManagerService,
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
  ) {


  }
  preferenceSummary: FormGroup;

  ngOnInit() {

    this.reqId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_NAME);
    this.userName = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
    this.APIgetEntitySummary();
    // this.dataSource.sort = this.sort;
    this.preferenceSummary = this.fb.group({
      fromDate: [''],
      toDate: ['',[Validators.required]],
      status: ['']
    });
    console.log(this.startDate1)
    this.maxDate.setDate(new Date().getDate());

  }
  APIgetEntitySummary() {
    var status = {
      Entity_Status: "C"

    }
    this.imp.getEntityWorklist(status).subscribe({
      next: value => {
     
        this.dataSubject.next(value);
        this.dataSource = new MatTableDataSource();

        this.dataSource = new MatTableDataSource(value);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        console.log("dataSource : ", this.dataSource);
      }
    });
  }

  downloadentityworklistcsvfile() {


    var fileName;
    const currentdat = formatDate(now, 'medium', 'en-US', '+0530');
    this.imp.downloadentityworklistcsvfile(this.data).subscribe(r => {
      fileName = currentdat + '_Active Entity.csv';
      importedSaveAs(r, fileName)
      //  this.downloadFile(r, Batch_Id);
      this.$modal.successModal({
        title: 'Entity Summary',
        msg: 'File has been downloaded Successfully'
      });
    })

  }


  
  getEntityWorklist() {
    var status = {
      Entity_Status: "C"

    }
    this.imp.getEntityWorklist(status)
      .subscribe({
        next: value => {
          this.dataSubject.next(value);
          this.dataSource = new MatTableDataSource();

          this.dataSource = new MatTableDataSource(value);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });

  }
  onApplyFilter1(filterForm1) {
    console.log(filterForm1.value);
  }
  reset() {
    this.data = {}
    console.log("inside res");
    //this.afterReset();  
    this.getEntityWorklist();
    console.log("done reset");
    this.showDropdown = false
    this.showDropdown1 = false
    this.showDropdown2 = false;
  }
  openDropdown(value) {
    this.form1.searchBy2=null
    this.form1.searchBy3=null
    this.form1.searchBy4=null
    this.form1.searchBy5=null
    this.form1.search=null

    console.log("value", value)
    this.form1.searchBy2 = "";
    if (value == "Entity_Classification") {
      this.showDropdown = true;
      this.showDropdown1 = false;
      this.showDropdown2 = false
    }
    else if (value == "RequestType") {
      this.showDropdown1 = true;
      this.showDropdown = false;
      this.showDropdown2 = false;
    } 
    else if (value == "Creator") {
      this.showDropdown1 = false;
      this.showDropdown = false;
      this.showDropdown2 = true;
    } 
    else {
      this.showDropdown2 = false;
      this.showDropdown = false;
      this.showDropdown1 = false;
    }
    //this.form1.searchBy2 = ""; 
    this.form1.search="";
  }  
}
export class MyDataSource extends DataSource<any[]> { 

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }

}


